import React, { useState } from 'react'
import { Box, Paper, Tabs, Typography, useTheme, Tab } from '@mui/material';
import { makeStyles } from '@mui/styles';
import UpcomingSchedule from './UpcomingSchedule';
import CompletedSchedule from '../myexam/Schedule';


const useStyles = makeStyles(() => ({
  header: {
    fontSize: '18px',
    fontWeight: '500',
  },
  container: {
    borderRadius: '8px',
    background: '#ffffff',
    marginTop: '32px',
    minHeight: 'calc(100vh - 120px)',
    position: 'relative',
  },
  tabRoot: {
    textTransform: 'capitalize', // 👈 make labels capitalized
    fontSize: '16px',
    fontWeight: 500,
  },
}));

// Custom TabPanel
interface TabPanelProps {
  children?: React.ReactNode;
  value: string;
  index: string;
}
const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
};

const Schedule = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState('one');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Paper className="d-flex justify-content-between align-items-center" sx={{ p: 2 }}>
        <Typography className={classes.header}>My exams</Typography>
      </Paper>

      <Box className={classes.container}>
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            textColor="secondary"
            aria-label="exam tabs"
          >
            <Tab classes={{ root: classes.tabRoot }} value="one" label="Upcoming" />
            <Tab classes={{ root: classes.tabRoot }} value="two" label="Completed" />
          </Tabs>
        </Box>

        {/* Tab Panels */}
        <TabPanel value={value} index="one">
          <UpcomingSchedule />
        </TabPanel>
        <TabPanel value={value} index="two">
          <CompletedSchedule />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default Schedule;
